import { useState } from 'react';
import axios from 'axios';
const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const authObject = {
      'Project-ID': 'f7dc7d99-802a-406c-8997-c154776984a3',
      'User-Name': username,
      'User-Secret': password,
    };

    try {
      // username | password => chatengine => give messages
      await axios.get('https://api.chatengine.io/chats', {
        headers: authObject,
      });
      // works out =>> logged in

      localStorage.setItem('username', username);
      localStorage.setItem('password', password);
      window.location.reload();
    } catch (error) {
      // error => try with new username...
      setError('Oops, incorrect username and password');
    }
  };

  return (
    <div className='wrapper'>
      <div className='form'>
        <h1>React Chat App </h1>
        <form onSubmit={handleSubmit}>
          <input
            type='text'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className='input'
            placeholder='User Name'
            required
          />
          <input
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className='input'
            placeholder='Password'
            required
          />
          <div align='center'>
            <button type='submit' className='button'>
              <span>Start Chatting</span>
            </button>
          </div>
          <h2 className='error'>{error}</h2>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
